import { TableColumnDef, buildGridTemplate } from '../../../utils/tableColumns';
import { MemberSortField } from '../types';

export type MemberColumnId =
    | 'member'
    | 'patientId'
    | 'device'
    | 'memberSince'
    | 'careManager'
    | 'caregivers'
    | 'status'
    | 'checkin'
    | 'membership'
    | 'role';

export type MemberColumnDef = TableColumnDef<MemberColumnId, MemberSortField>;

/** Single source of truth for the Members list columns: header, grid track, and toggle state. */
export const MEMBER_COLUMNS: MemberColumnDef[] = [
    // Sorts on the surname, matching the name this cell leads with rather than the email beneath it.
    { id: 'member', label: 'Member', size: '3fr', alwaysVisible: true, sortField: 'last_name' },
    { id: 'patientId', label: 'Patient ID', size: '1.5fr', defaultVisible: false },
    { id: 'device', label: 'Device ID', size: '1.8fr' },
    { id: 'memberSince', label: 'Member since', size: '1.8fr', sortField: 'activated_at' },
    { id: 'careManager', label: 'Care Manager', size: '2.4fr' },
    { id: 'caregivers', label: 'Caregivers', size: '2.8fr' },
    { id: 'status', label: 'Device Status', size: '1.6fr' },
    // Sorts on the scheduled date rather than the status pill above it — the only check-in ordering
    // the endpoint offers.
    {
        id: 'checkin',
        label: 'Monthly Check-in',
        size: '2fr',
        sortField: 'cm_checkin_schedule_date'
    },
    { id: 'membership', label: 'Membership', size: '1.6fr', defaultVisible: false },
    { id: 'role', label: 'Role', size: '2.2fr', defaultVisible: false }
];

export const MEMBER_COLUMNS_STORAGE_KEY = 'ep:columns:members';

/** Bulk-select checkbox column track, prepended when bulk mode is active. */
const BULK_TRACK = '4rem';

/** Mandatory trailing track for the device alert indicator (always shown, not toggleable). */
const ALERT_TRACK = '3.6rem';

export const getMemberGridTemplate = (
    columns: TableColumnDef<MemberColumnId>[],
    isVisible: (id: MemberColumnId) => boolean,
    isBulkMode: boolean,
    isMinL: boolean
): string =>
    buildGridTemplate(columns, isVisible, {
        leadingTracks: isBulkMode ? [BULK_TRACK] : [],
        trailingTracks: [ALERT_TRACK],
        collapsed: !isMinL
    });
